import {
  inMemoryPersistence,
  setPersistence,
  signInWithCustomToken,
  signOut,
} from "firebase/auth";
import { getFirebaseAuth } from "./config";

let authGeneration = 0;
let authQueue: Promise<void> = Promise.resolve();
let signInAllowed = true;

function enqueueAuth(operation: () => Promise<void>): Promise<void> {
  const next = authQueue.catch(() => undefined).then(operation);
  authQueue = next;
  return next;
}

/**
 * Serialize Firebase Auth changes. A custom-token sign-in that was requested
 * before logout may finish, but logout is queued behind it and therefore owns
 * the final Firebase user state.
 */
export function signInSellerFirebaseAuth(customToken: string): Promise<void> {
  const generation = authGeneration;
  return enqueueAuth(async () => {
    if (generation !== authGeneration || !signInAllowed) return;
    const auth = getFirebaseAuth();
    if (!auth) return;
    await setPersistence(auth, inMemoryPersistence);
    await signInWithCustomToken(auth, customToken);
  });
}

export function activateSellerFirebaseAuthSession(): void {
  authGeneration += 1;
  signInAllowed = true;
}

export function signOutSellerFirebaseAuth(): Promise<void> {
  authGeneration += 1;
  signInAllowed = false;
  return enqueueAuth(async () => {
    const auth = getFirebaseAuth();
    if (!auth) return;
    await signOut(auth);
  });
}
